
import { Component, OnInit, Input } from '@angular/core';
import { FeedbackService } from '../feedback.service';
import { ConfigurationService } from '../configuration.service';

@Component({
    selector: 'feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
    @Input() feedbackInput: string;
    isOpen = false;

    constructor(private feedbackService: FeedbackService, private configService: ConfigurationService) { }

    ngOnInit() {
    }


    submit(): void {
        let itemFullTitle = document.title;
        let screenRes = screen.width + 'x' + screen.height;
        let referer = window.location.href;

        let feedbackObj = {
            surveyId: this.configService.configuration.feedbackKey, // this is the Qualtrics survey id
            feedback: this.feedbackInput, // user input
            section: itemFullTitle, // page title, eg.Home, About PJM ect
            referer: referer, // current page url
            screenResolution: screenRes, // width x height
            username: '', // current user display name
            longitude: '',
            latitude: ''
        };

        console.log(feedbackObj);

        this.feedbackService.submit(feedbackObj);
        // close after submitting
        // this.isOpen = false;
    }

    toggle(): void {
        this.isOpen = !this.isOpen;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/feedback/feedback.component.ts